export const BuildInfo = {timestamp:1792606115000}
